// extracted by mini-css-extract-plugin
export var skipAnimation = "_1n-0";